import React, {useState} from "react";
import styled from 'styled-components';
import WebAuthService from "./../../services/WebAuthService";


import FormRegistration from "./Authenticator/FormRegistration";
import FormEmailValidation from "./Authenticator/FormEmailValidation";
import FormLogin from "./Authenticator/FormLogin";
import FormNewPassword from "./Authenticator/FormNewPassword";
import FormNewPasswordNoCode from "./Authenticator/FormNewPasswordNoCode";
import FormForgotPassword from "./Authenticator/FormForgotPassword";
// import FormRecoverPassword from "./Authenticator/FormRecoverPassword";
import FormSetName from "./Authenticator/FormSetName";
import FormSuccess from "./Authenticator/FormSuccess";


import Logo from "./Logo.js";
import Container from "./Container.js";

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
`;


const Authentication = ({
  entryPoint = "login",
  enableRegistration=true,
  requiredGroup=null,
  userPoolId,
  clientId,
  region,
  identityPoolId = null,
  onSuccess
}) => {
  const [AuthService] = useState( new WebAuthService({
    userPoolId: userPoolId,
    clientId: clientId,
    region: region,
    identityPoolId: identityPoolId
  }));
  const [page, setPage] = useState(entryPoint);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState(null);
  const [sessionUser, setSessionUser] = useState(null);

  const responseHandler = (response) => {
    switch(response.action){
      case "registration":
        registration(response.params.email, response.params.password1, response.params.password2, response.params.givenName, response.params.familyName, response.params.locale);
        break;
      case "email-validation":
        setEmailValidation(response.params.email, response.params.code);
        break;
      case "login":
        login(response.params.email, response.params.password);
        break;
      case "new-password":
        setNewPassword(response.params.password1, response.params.password2, response.params.code);
        break;
      case "new-password-nocode":
        setNewPasswordNoCode(response.params.password1, response.params.password2);
        break;
      case "forgot-password":
        forgotPassword(response.params.email);
        break;
      // case "recover-password":
      //   recoverPassword(response.params.code, response.params.password1, response.params.password2);
      //   break;
      case "navigate":
        setPage(response.params.page);
        break;
      default:
        break;
    }
  };

  const registration = (email, password1, password2, givenName, familyName, locale) => {
    setError(null);
    AuthService.registration(email, password1, givenName, familyName, locale).then(response => {
      if(!response.UserConfirmed){
        setSessionUser({
          email: email,
          givenName: givenName,
          familyName: familyName
        });
        setPage("email-validation");
      }else{
        setPage("login");
      }
    }).catch(error => {
      console.log(error);
      setError(error.message);
    });
  };


  const login = (email, password) => {
    setError(null);
    AuthService.login(email, password).then(response => {
      if(!requiredGroup || (response.JwtToken["cognito:groups"] && response.JwtToken["cognito:groups"].includes(requiredGroup))){
        setPage("success");
        onSuccess(response);
      }else{
        setError("Non hai i permessi.");
      }
    }).catch(error => {
      switch (error.ChallengeName) {
        case "NEW_PASSWORD_REQUIRED":
          setEmail(email);
          setSessionUser(error.Session);
          setPage("new-password-nocode");
          // forgotPassword(email);
          break;
        default:
          setError(error.message);
          break;
      }
    });
  };

  const setEmailValidation = (email, code) => {
    setError(null);
    AuthService.emailValidation(email, code).then(response => {
      setPage("login");
    }).catch(response => {
      console.log(response);
      setError(response.error.message);
    });
  };

  const forgotPassword = (email) => {
    setError(null);
    AuthService.forgotPassword(email).then(response => {
      setSessionUser(email);
      setPage("new-password");
    }).catch(response => {
      console.log(response);
      setError(response.error.message);
    });
  };

  const setNewPassword = (password1, password2, code) => {
    setError(null);
    AuthService.setNewPassword(sessionUser, password1, code).then(response => {
      setPage("login"); //success
      // onSuccess(response.data); // ???
    }).catch(response => {
      console.log(response);
      setError(response.message);
    });
  };

  const setNewPasswordNoCode = (password1, password2) => {
    setError(null);
    AuthService.newPasswordChallenge(email, password1, sessionUser).then(response => {
      if(!requiredGroup || (response.JwtToken["cognito:groups"] && response.JwtToken["cognito:groups"].includes(requiredGroup))){
        setPage("success");
        onSuccess(response);
      }else{
        setError("Non hai i permessi.");
      }
    }).catch(response => {
      console.log(response);
      setError(response.message);
    });
  };

  // const recoverPassword = (code, password1) => {
  //   setError(null);
  //   AuthService.recoverPassword(sessionUser, code, password1).then(response => {
  //     if(response.success){
  //       setPage("success");
  //     }else{
  //       setError(response.error.message);
  //     }
  //   }).catch(response => {
  //     console.log(response);
  //     setError(response.error.message);
  //   });
  // };

  return (
    <Wrapper>
      <Container size="small">
        <Logo height="60px"/>
        <br/><br/>
        {page === "registration" && enableRegistration ?
          <FormRegistration
            onConfirm={(response) => responseHandler(response)}
            error={error}
          />
        : page === "email-validation" && sessionUser ?
          <FormEmailValidation
            sessionUser={sessionUser}
            onConfirm={(response) => responseHandler(response)}
            error={error}
          />
        : page === "login" ?
          <FormLogin
            enableRegistration={enableRegistration}
            onConfirm={(response) => responseHandler(response)}
            error={error}
          />
        : page === "set-name" && sessionUser ?
          <FormSetName
            onConfirm={(response) => responseHandler(response)}
            error={error}
          />
        : page === "forgot-password" ?
          <FormForgotPassword
            onConfirm={(response) => responseHandler(response)}
            error={error}
          />
        : page === "new-password" && sessionUser ?
          <FormNewPassword
            sessionUser={sessionUser}
            onConfirm={(response) => responseHandler(response)}
            error={error}
          />
        : page === "new-password-nocode" && sessionUser ?
          <FormNewPasswordNoCode
            sessionUser={sessionUser}
            onConfirm={(response) => responseHandler(response)}
            error={error}
          />
        // : page === "recover-password" ?
        //   <FormRecoverPassword
        //     sessionUser={sessionUser}
        //     onConfirm={(response) => responseHandler(response)}
        //     error={error}
        //   />
        : page === "success" ?
          <FormSuccess
            onConfirm={(response) => responseHandler(response)}
          />
        : <>error</> }
      </Container>
    </Wrapper>
  )
}

export default Authentication;
